import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MobileService {

  ANDROID = 'Android';
  IOS = 'iOS';

  // tslint:disable-next-line:variable-name
  private _isMobileAppSubject: BehaviorSubject<boolean> = new BehaviorSubject(true);
  isMobileAppSubject$: Observable<boolean> = this._isMobileAppSubject.asObservable();


  constructor() { }

  isMobileApp: boolean = false;
  appPlatform: string;

  init() {
    const platform = localStorage.getItem('appPlatform');
    if (platform === this.ANDROID || platform === this.IOS) {
      this._isMobileAppSubject.next(true);
      this.isMobileApp = true;
      this.appPlatform = platform;
    } else {
      this._isMobileAppSubject.next(false);
    }
  }

  setPlatformType(platform: string) {
    if (platform === this.ANDROID || platform === this.IOS) {
      this.isMobileApp = true;
      this._isMobileAppSubject.next(true);
      localStorage.setItem('appPlatform', platform);
    } else {
      // if we already know that this is mobile shell, then we skip
      if (this.getPlatformType() !== this.IOS && this.getPlatformType() !== this.ANDROID) {
        this._isMobileAppSubject.next(false);
        this.isMobileApp = false;
      }
    }
  }

  getPlatformType() {
    return localStorage.getItem('appPlatform');
  }
}
